import { ApolloClientName } from 'apollo-client-factory';
import { useSetAntiFraudApplicantForLoanApplicationMutation } from 'generated/credit-analysis-graphql';

const useApplicantHandler = () => {
    const [setAntiFraudApplicantForLoanApplication] = useSetAntiFraudApplicantForLoanApplicationMutation({
        context: {
            clientName: ApolloClientName.CreditAnalysisApi,
        },
    });

    return setAntiFraudApplicantForLoanApplication;
};

export default useApplicantHandler;
